import { useRequiredContext } from "@suse-o11y/use-required-context";
import { createContext } from "react";

export type ToggleListLocation = "trigger" | "content";

const ToggleListLocationContext = createContext<null | ToggleListLocation>("trigger");

export const ToggleListLocationContextProvider = ToggleListLocationContext.Provider;

export const useToggleListLocation = (): ToggleListLocation =>
	useRequiredContext(ToggleListLocationContext, {
		providerName: "ToggleListLocation(Content|Trigger)",
	});
